// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3whMR","tabsBox":"styles_tabsBox__1jQKX","createButton":"styles_createButton__3dS6S"};